 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"Pages-CustomTemplateSetting-vue~Pages-Orders-vue~Pages-Payments-vue~Pages-Users-vue~Pages-order-Orde~009f5e47":"Pages-CustomTemplateSetting-vue~Pages-Orders-vue~Pages-Payments-vue~Pages-Users-vue~Pages-order-Orde~009f5e47","Pages-CustomTemplateSetting-vue":"Pages-CustomTemplateSetting-vue","Pages-Orders-vue~Pages-Payments-vue~Pages-Users-vue~Pages-user-EditUser-vue":"Pages-Orders-vue~Pages-Payments-vue~Pages-Users-vue~Pages-user-EditUser-vue","Pages-Orders-vue":"Pages-Orders-vue","Pages-Payments-vue":"Pages-Payments-vue","Pages-Users-vue":"Pages-Users-vue","Pages-user-EditUser-vue":"Pages-user-EditUser-vue","Pages-order-OrderDetail-vue":"Pages-order-OrderDetail-vue","Pages-template_setting-Bundle-vue":"Pages-template_setting-Bundle-vue","Pages-template_setting-Tags-vue":"Pages-template_setting-Tags-vue","Pages-template_setting-Template_Size-vue":"Pages-template_setting-Template_Size-vue","Pages-template_setting-Templates-vue":"Pages-template_setting-Templates-vue","Pages-template_setting-Templates_Type-vue~Pages-template_setting-Themes-vue":"Pages-template_setting-Templates_Type-vue~Pages-template_setting-Themes-vue","Pages-template_setting-Templates_Type-vue":"Pages-template_setting-Templates_Type-vue","Pages-template_setting-Themes-vue":"Pages-template_setting-Themes-vue","Pages-DeleteCache-vue":"Pages-DeleteCache-vue","Pages-auth-Auth-vue":"Pages-auth-Auth-vue","Pages-auth-login-vue":"Pages-auth-login-vue","Pages-bundle-AddBundle-vue~Pages-bundle-EditBundle-vue":"Pages-bundle-AddBundle-vue~Pages-bundle-EditBundle-vue","Pages-bundle-AddBundle-vue":"Pages-bundle-AddBundle-vue","Pages-bundle-EditBundle-vue":"Pages-bundle-EditBundle-vue","Pages-template-AddFont-vue":"Pages-template-AddFont-vue","Pages-template-AddTemplate-vue":"Pages-template-AddTemplate-vue","Pages-template-EditTemplate-vue":"Pages-template-EditTemplate-vue","Pages-template_setting-Fonts-vue":"Pages-template_setting-Fonts-vue","Vusenavs":"Vusenavs","lang-en":"lang-en","lang-en-vuse-AppDrawer":"lang-en-vuse-AppDrawer","lang-fr-FR":"lang-fr-FR","lang-fr-FR-vuse-AppDrawer":"lang-fr-FR-vuse-AppDrawer","lang-ja-JP":"lang-ja-JP","lang-ja-JP-vuse-AppDrawer":"lang-ja-JP-vuse-AppDrawer","lang-ru-RU":"lang-ru-RU","lang-ru-RU-vuse-AppDrawer":"lang-ru-RU-vuse-AppDrawer"}[chunkId]||chunkId) + "." + {"Pages-CustomTemplateSetting-vue~Pages-Orders-vue~Pages-Payments-vue~Pages-Users-vue~Pages-order-Orde~009f5e47":"e2d28079","Pages-CustomTemplateSetting-vue":"d187d825","Pages-Orders-vue~Pages-Payments-vue~Pages-Users-vue~Pages-user-EditUser-vue":"ce605213","Pages-Orders-vue":"ea020bf1","Pages-Payments-vue":"02305ae6","Pages-Users-vue":"f5baa344","Pages-user-EditUser-vue":"f45b430f","Pages-order-OrderDetail-vue":"66f58a73","Pages-template_setting-Bundle-vue":"46b38edd","Pages-template_setting-Tags-vue":"a041cab7","Pages-template_setting-Template_Size-vue":"1e949f09","Pages-template_setting-Templates-vue":"80255fc7","Pages-template_setting-Templates_Type-vue~Pages-template_setting-Themes-vue":"90fba739","Pages-template_setting-Templates_Type-vue":"5adfa03c","Pages-template_setting-Themes-vue":"d7bf118a","Pages-DeleteCache-vue":"a3ecfff4","Pages-auth-Auth-vue":"0881a9a2","Pages-auth-login-vue":"70ce680a","Pages-bundle-AddBundle-vue~Pages-bundle-EditBundle-vue":"37617de0","Pages-bundle-AddBundle-vue":"6f199f9d","Pages-bundle-EditBundle-vue":"103e4a83","Pages-template-AddFont-vue":"c800a22f","Pages-template-AddTemplate-vue":"fe15ce2c","Pages-template-EditTemplate-vue":"11e09ac1","Pages-template_setting-Fonts-vue":"7e8ecaec","Vusenavs":"6472a680","lang-en":"48e78094","lang-en-vuse-AppDrawer":"abc00169","lang-fr-FR":"1f2f3d2c","lang-fr-FR-vuse-AppDrawer":"43211fdb","lang-ja-JP":"32dbdf41","lang-ja-JP-vuse-AppDrawer":"90bf6405","lang-ru-RU":"da426391","lang-ru-RU-vuse-AppDrawer":"ecdc86cc"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"Pages-CustomTemplateSetting-vue~Pages-Orders-vue~Pages-Payments-vue~Pages-Users-vue~Pages-order-Orde~009f5e47":1,"Pages-CustomTemplateSetting-vue":1,"Pages-Orders-vue~Pages-Payments-vue~Pages-Users-vue~Pages-user-EditUser-vue":1,"Pages-Payments-vue":1,"Pages-user-EditUser-vue":1,"Pages-order-OrderDetail-vue":1,"Pages-template_setting-Bundle-vue":1,"Pages-template_setting-Tags-vue":1,"Pages-template_setting-Template_Size-vue":1,"Pages-template_setting-Templates-vue":1,"Pages-template_setting-Templates_Type-vue~Pages-template_setting-Themes-vue":1,"Pages-template_setting-Templates_Type-vue":1,"Pages-template_setting-Themes-vue":1,"Pages-auth-Auth-vue":1,"Pages-auth-login-vue":1,"Pages-bundle-AddBundle-vue~Pages-bundle-EditBundle-vue":1,"Pages-bundle-AddBundle-vue":1,"Pages-bundle-EditBundle-vue":1,"Pages-template-AddFont-vue":1,"Pages-template-AddTemplate-vue":1,"Pages-template-EditTemplate-vue":1,"Pages-template_setting-Fonts-vue":1,"Vusenavs":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"Pages-CustomTemplateSetting-vue~Pages-Orders-vue~Pages-Payments-vue~Pages-Users-vue~Pages-order-Orde~009f5e47":"Pages-CustomTemplateSetting-vue~Pages-Orders-vue~Pages-Payments-vue~Pages-Users-vue~Pages-order-Orde~009f5e47","Pages-CustomTemplateSetting-vue":"Pages-CustomTemplateSetting-vue","Pages-Orders-vue~Pages-Payments-vue~Pages-Users-vue~Pages-user-EditUser-vue":"Pages-Orders-vue~Pages-Payments-vue~Pages-Users-vue~Pages-user-EditUser-vue","Pages-Orders-vue":"Pages-Orders-vue","Pages-Payments-vue":"Pages-Payments-vue","Pages-Users-vue":"Pages-Users-vue","Pages-user-EditUser-vue":"Pages-user-EditUser-vue","Pages-order-OrderDetail-vue":"Pages-order-OrderDetail-vue","Pages-template_setting-Bundle-vue":"Pages-template_setting-Bundle-vue","Pages-template_setting-Tags-vue":"Pages-template_setting-Tags-vue","Pages-template_setting-Template_Size-vue":"Pages-template_setting-Template_Size-vue","Pages-template_setting-Templates-vue":"Pages-template_setting-Templates-vue","Pages-template_setting-Templates_Type-vue~Pages-template_setting-Themes-vue":"Pages-template_setting-Templates_Type-vue~Pages-template_setting-Themes-vue","Pages-template_setting-Templates_Type-vue":"Pages-template_setting-Templates_Type-vue","Pages-template_setting-Themes-vue":"Pages-template_setting-Themes-vue","Pages-DeleteCache-vue":"Pages-DeleteCache-vue","Pages-auth-Auth-vue":"Pages-auth-Auth-vue","Pages-auth-login-vue":"Pages-auth-login-vue","Pages-bundle-AddBundle-vue~Pages-bundle-EditBundle-vue":"Pages-bundle-AddBundle-vue~Pages-bundle-EditBundle-vue","Pages-bundle-AddBundle-vue":"Pages-bundle-AddBundle-vue","Pages-bundle-EditBundle-vue":"Pages-bundle-EditBundle-vue","Pages-template-AddFont-vue":"Pages-template-AddFont-vue","Pages-template-AddTemplate-vue":"Pages-template-AddTemplate-vue","Pages-template-EditTemplate-vue":"Pages-template-EditTemplate-vue","Pages-template_setting-Fonts-vue":"Pages-template_setting-Fonts-vue","Vusenavs":"Vusenavs","lang-en":"lang-en","lang-en-vuse-AppDrawer":"lang-en-vuse-AppDrawer","lang-fr-FR":"lang-fr-FR","lang-fr-FR-vuse-AppDrawer":"lang-fr-FR-vuse-AppDrawer","lang-ja-JP":"lang-ja-JP","lang-ja-JP-vuse-AppDrawer":"lang-ja-JP-vuse-AppDrawer","lang-ru-RU":"lang-ru-RU","lang-ru-RU-vuse-AppDrawer":"lang-ru-RU-vuse-AppDrawer"}[chunkId]||chunkId) + "." + {"Pages-CustomTemplateSetting-vue~Pages-Orders-vue~Pages-Payments-vue~Pages-Users-vue~Pages-order-Orde~009f5e47":"18bc4a4a","Pages-CustomTemplateSetting-vue":"695142fd","Pages-Orders-vue~Pages-Payments-vue~Pages-Users-vue~Pages-user-EditUser-vue":"8aaa2b48","Pages-Orders-vue":"31d6cfe0","Pages-Payments-vue":"adbac97b","Pages-Users-vue":"31d6cfe0","Pages-user-EditUser-vue":"d07fd413","Pages-order-OrderDetail-vue":"31f2ac68","Pages-template_setting-Bundle-vue":"0d8b80df","Pages-template_setting-Tags-vue":"19c00e38","Pages-template_setting-Template_Size-vue":"a7373463","Pages-template_setting-Templates-vue":"48ea3f4d","Pages-template_setting-Templates_Type-vue~Pages-template_setting-Themes-vue":"b8cd4a67","Pages-template_setting-Templates_Type-vue":"1df07194","Pages-template_setting-Themes-vue":"63058fa5","Pages-DeleteCache-vue":"31d6cfe0","Pages-auth-Auth-vue":"0e433876","Pages-auth-login-vue":"330669d2","Pages-bundle-AddBundle-vue~Pages-bundle-EditBundle-vue":"663f8951","Pages-bundle-AddBundle-vue":"2009d059","Pages-bundle-EditBundle-vue":"5bac7a41","Pages-template-AddFont-vue":"9b6d98be","Pages-template-AddTemplate-vue":"17241e26","Pages-template-EditTemplate-vue":"7ee90b15","Pages-template_setting-Fonts-vue":"30bc43f7","Vusenavs":"802a1a23","lang-en":"31d6cfe0","lang-en-vuse-AppDrawer":"31d6cfe0","lang-fr-FR":"31d6cfe0","lang-fr-FR-vuse-AppDrawer":"31d6cfe0","lang-ja-JP":"31d6cfe0","lang-ja-JP-vuse-AppDrawer":"31d6cfe0","lang-ru-RU":"31d6cfe0","lang-ru-RU-vuse-AppDrawer":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
